export const setGlobalCursor = cursor => {
  const body = document.getElementsByTagName('body')[0];

  body.style.setProperty('cursor', cursor, 'important');
};

export const resetGlobalCursor = () =>
  document.getElementsByTagName('body')[0].style.removeProperty('cursor');
